/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { CardContainer } from "../../../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../../../components/page-skeleton/PageHeader";
import { UserMembercardsList } from "./UserMembercardsList";
import { useGetUserMemberCards } from "../../../../service/api";
import { PrimaryButton } from "../../../../components/Buttons";
import { colors } from "../../../../components/colors";
import AddMemberCardPopup from "../../../common/AddMemberCardPopup";
import { CardBody } from "../../../../components/page-skeleton/CardBody";
import { cardBottomPadding } from "../../../../style-util";
import { useSelector } from "react-redux";
import * as authSelectors from "../../../auth/authSelectors";
import { useHandleFetchError } from "../../../../error-handler";

// Temp solution. Until all places have CardContainer component we have to override margin-top if other than 32px is desired.
const containerMarginTop = css`
  margin-top: 24px !important;
`;

export const UserMembercards = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const [showModal, setShowModal] = useState(false);
  const { data, isLoading, error } = useGetUserMemberCards(
    organizationKeyName,
    id
  );

  useHandleFetchError(error);

  return (
    <>
      <CardContainer css={containerMarginTop}>
        <PageHeader title="Member cards">
          <PrimaryButton
            type="button"
            hoverColor={colors.ctaLight}
            color={colors.ctaMain}
            backgroundColor={colors.white}
            onClick={() => setShowModal(true)}
            className="w-fit"
          >
            Add member card
          </PrimaryButton>
        </PageHeader>
        <CardBody css={cardBottomPadding}>
          <UserMembercardsList isLoading={isLoading} membercards={data} />
        </CardBody>
      </CardContainer>
      {showModal && (
        <AddMemberCardPopup
          userId={id}
          organization={organizationKeyName}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};
